<template>
  <div class="w-full h-full flex items-center justify-center">
    <ClientOnly>
      <div
        ref="container"
        class="w-full h-full max-w-[320px] max-h-[320px]"
      />
      <template #fallback>
        <!-- SSR 佔位，保持節點數一致，避免 hydration mismatch -->
        <div class="w-full h-full max-w-[320px] max-h-[320px]" />
      </template>
    </ClientOnly>
  </div>
</template>

<script setup lang="ts">
import lottie, { type AnimationItem } from 'lottie-web';
import { nextTick, onBeforeUnmount, onMounted, ref } from 'vue';

const container = ref<HTMLDivElement | null>(null);
let animation: AnimationItem | null = null;

onMounted(async () => {
  // 等待下一個 tick，確保 ClientOnly 已經掛載並建立 ref
  await nextTick();
  if (!container.value) return;

  animation = lottie.loadAnimation({
    container: container.value,
    renderer: 'svg',
    loop: true,
    autoplay: true,
    // 使用匯出的 JSON 動畫
    path: '/videos/authLogo.json',
  });
});

onBeforeUnmount(() => {
  if (animation) {
    animation.destroy();
    animation = null;
  }
});
</script>


